export const NOTIFICATION_TYPES = [
    { value: 'general', label: 'عام' },
    { value: 'news', label: 'خبر' },
    { value: 'document', label: 'وثيقة' },
    { value: 'event', label: 'فعالية' },
    { value: 'member', label: 'عضو' },
    { value: 'admin', label: 'إداري' }
]

export const NOTIFICATION_CREATE_REQUEST = 'NOTIFICATION_CREATE_REQUEST'
export const NOTIFICATION_CREATE_SUCCESS = 'NOTIFICATION_CREATE_SUCCESS'
export const NOTIFICATION_CREATE_FAIL = 'NOTIFICATION_CREATE_FAIL'
export const NOTIFICATION_CREATE_CLEAR = 'NOTIFICATION_CREATE_CLEAR'

export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST'
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS'
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL'

export const NOTIFICATION_ADMIN_LIST_REQUEST = 'NOTIFICATION_ADMIN_LIST_REQUEST'
export const NOTIFICATION_ADMIN_LIST_SUCCESS = 'NOTIFICATION_ADMIN_LIST_SUCCESS'
export const NOTIFICATION_ADMIN_LIST_FAIL = 'NOTIFICATION_ADMIN_LIST_FAIL'

export const NOTIFICATION_UNREAD_COUNT_REQUEST = 'NOTIFICATION_UNREAD_COUNT_REQUEST'
export const NOTIFICATION_UNREAD_COUNT_SUCCESS = 'NOTIFICATION_UNREAD_COUNT_SUCCESS'
export const NOTIFICATION_UNREAD_COUNT_FAIL = 'NOTIFICATION_UNREAD_COUNT_FAIL'

export const NOTIFICATION_MARK_READ_SUCCESS = 'NOTIFICATION_MARK_READ_SUCCESS'
export const NOTIFICATION_MARK_ALL_READ_SUCCESS = 'NOTIFICATION_MARK_ALL_READ_SUCCESS'

export const NOTIFICATION_DELETE_REQUEST = 'NOTIFICATION_DELETE_REQUEST'
export const NOTIFICATION_DELETE_SUCCESS = 'NOTIFICATION_DELETE_SUCCESS'
export const NOTIFICATION_DELETE_FAIL = 'NOTIFICATION_DELETE_FAIL'
export const NOTIFICATION_DELETE_CLEAR = 'NOTIFICATION_DELETE_CLEAR'
